import React from 'react';

import Button from '../../../library/button/button';
import Typography from '../../../library/typography/typography';
import MessageDotsSolidIcon from '../../../shared/icons/message-dots-solid-icon';

import useLivePersonChatButton from '../../../shared/hooks/use-live-person-chat-button/use-live-person-chat-button';

import { LIVE_PERSON_CHAT_BUTTON_IDS } from '../../../shared/constants/live-person-chat-btn-ids';

import styles from './cec-contact-us-chat-button.scss';

function CecContactUsChatButton() {
  const { isLoading, onClick } = useLivePersonChatButton(
    LIVE_PERSON_CHAT_BUTTON_IDS.CEC_CONTACT_US
  );

  return (
    <span className={styles['container']}>
      <div
        className={styles['lp-button']}
        data-testid={LIVE_PERSON_CHAT_BUTTON_IDS.CEC_CONTACT_US}
        id={LIVE_PERSON_CHAT_BUTTON_IDS.CEC_CONTACT_US}
      />
      {!isLoading && (
        <>
          <span className={styles['text-before-button']}>or</span>
          <Button
            className={styles['button']}
            data-testid="cec-contact-us-chat-button__button"
            onClick={onClick}
          >
            <MessageDotsSolidIcon className={styles['icon']} />
            <Typography className={styles['text']} tag="span">
              Chat
            </Typography>
          </Button>
        </>
      )}
    </span>
  );
}

export default CecContactUsChatButton;
